import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <ul className="greenbullet-list">
                                                <li>Consider past projects and experiences you have gone through
                                                    and learn from these
                                                    successes or failures to help make your decision.
                                                </li>
                                                <li>Categorise potential problems into high and low risk areas.
                                                    When doing that, consider how
                                                    likely it is that the problem will occur and how damaging it
                                                    would actually be. Carry out a
                                                    risk analysis using a grid like the one below:
                                                </li>
                                            </ul>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/risk_graph2.png')}
                                                    alt=""/>
                                            </div>


                                            <p>Your objective is to think of strategies that will result in any
                                                risk that falls in the top right corner
                                                moving ideally to the bottom left or at least to one of the
                                                other corners. This process will also help
                                                you to identify which issue you should tackle first and which
                                                issues you can afford to leave to last
                                                or even not deal with at all.
                                            </p>


                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Now that you know more about what’s involved in managing risk and
                                                have some practical tools,
                                                think about what to do next. Here are a few suggestions, but be
                                                willing to take other opportunities
                                                to develop your risk taking.</p>

                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find it useful to benchmark your current performance by
                                                asking for formal or informal
                                                feedback. You could help others, too, by making yourself
                                                available to share your views and
                                                experiences with them.</p>
                                            <div className="border_subtitle">Use the exercises in this tool
                                            </div>
                                            <p>Use the techniques outlined in this tool to help you manage your
                                                risk taking. This should increase
                                                your confidence that you’re taking more calculated risks.</p>
                                            <div className="border_subtitle">Seek out role models</div>
                                            <p>Consider how you would like to manage risk and find someone who
                                                you think does it well.
                                                Consider what you particularly admire about them or their
                                                approach and make comparisons with
                                                yourself. By being aware of the differences in your approaches,
                                                you may be able to provide
                                                potential steps to flex your style.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}